import ModalMainView from './modal-main-view';
export default ModalMainView;